import {
    AfterViewInit,
    Directive,
    ElementRef,
    Input,
    OnChanges,
    Renderer2,
} from '@angular/core'

/** Bridges validation semantics through ngx-intl-tel-input to its focusable input. */
@Directive({
    selector: 'ngx-intl-tel-input[appBookingPhoneAccessibility]',
    standalone: true,
})
export class BookingPhoneAccessibilityDirective implements AfterViewInit, OnChanges {
    @Input() bookingPhoneRequired = false
    @Input() bookingPhoneInvalid = false
    @Input() bookingPhoneDescribedBy: string | null = null

    constructor(
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly renderer: Renderer2
    ) { }

    ngAfterViewInit(): void {
        this.updateInputAttributes()
    }

    ngOnChanges(): void {
        this.updateInputAttributes()
    }

    private updateInputAttributes(): void {
        const input = this.elementRef.nativeElement.querySelector<HTMLInputElement>('input[type="tel"]')
        if (!input) {
            return
        }

        this.renderer.setProperty(input, 'required', this.bookingPhoneRequired)
        this.renderer.setAttribute(input, 'aria-required', String(this.bookingPhoneRequired))
        this.renderer.setAttribute(input, 'aria-invalid', String(this.bookingPhoneInvalid))
        if (this.bookingPhoneDescribedBy) {
            this.renderer.setAttribute(input, 'aria-describedby', this.bookingPhoneDescribedBy)
        } else {
            this.renderer.removeAttribute(input, 'aria-describedby')
        }
    }
}
